import { BdsLoadingSpinner, BdsPaper } from 'blip-ds/dist/blip-ds-react/components';
import { ChipTag } from 'components/ChipTag';
import { Grid } from 'components/Grid';
import { MetricsContent } from 'components/MetricsContent';
import { MetricsTitle } from 'components/MetricsTitle';
import { useTranslation } from 'react-i18next';
import { MetricsLoadingProps } from 'typings';

type TicketStatusProps = {
    totalToday?: number;
    closedToday?: number;
    closedByAttendant?: number;
    closedByClient?: number;
    missed?: number;
    loading: MetricsLoadingProps;
};

export function TicketStatus({
    totalToday,
    closedToday,
    closedByAttendant,
    closedByClient,
    missed,
    loading,
}: TicketStatusProps) {
    const { t } = useTranslation();
    return (
        <BdsPaper width="60%" className="metricsContainer" elevation="none">
            <Grid justifyContent="space-between" alignItems="center" margin="x-2">
                <MetricsTitle title={t('go-personal-ticket-status-title')} />
                <ChipTag
                    value={t('go-personal-loading-percentage', {
                        percentage: loading.ticketMetricsPercentageLoaded ?? 0,
                    })}
                    color={loading.ticketMetricsPercentageLoaded === 100 ? 'outline' : 'default'}
                />
            </Grid>
            {loading.isTicketMetricsLoading ? (
                <Grid justifyContent="center">
                    <BdsLoadingSpinner />
                </Grid>
            ) : (
                <Grid justifyContent="space-around" flexWrap="wrap" alignItems="center" margin="x-2" gap="3">
                    <MetricsContent metricsValue={totalToday}>{t('go-personal-ticket-status-total')}</MetricsContent>
                    <MetricsContent metricsValue={closedToday}>{t('go-personal-ticket-status-closed')}</MetricsContent>
                    <MetricsContent metricsValue={closedByAttendant}>{t('go-personal-ticket-status-attended')}</MetricsContent>
                    <MetricsContent metricsValue={closedByClient}>{t('go-personal-ticket-status-abandoned')}</MetricsContent>
                    <MetricsContent metricsValue={missed}>{t('go-personal-ticket-status-missed')}</MetricsContent>
                </Grid>
            )}
        </BdsPaper>
    );
}
